export function checkIfContradictiveRelationsExist(allRelations, relation) {
    return allRelations.some(existingRelation => {
        return (
            existingRelation.fromEntity._id === relation.toEntity._id &&
            existingRelation.toEntity._id === relation.fromEntity._id &&
            existingRelation.cardinality === "1-*" &&
            existingRelation.relationId !== relation.relationId
        );
    })
}